import * as React from 'react';
import { Ref, forwardRef, SVGProps } from 'react';
type IconSize = 6 | 12 | 14 | 16 | 17 | 20 | 24 | 48 | 64 | 96 | 104 | 126;
interface Props extends SVGProps<SVGSVGElement> {
  /** If specified, renders an inline title element */
  title?: string;
  /** The size of the icon */
  size?: IconSize;
  /** How many degrees the icon should be rotated */
  rotate?: number;
  className?: string;
  alt?: string;
}
const SvgCheckCircleSolid = ({
  size = 16,
  rotate,
  title,
  className,
  ...props
}: Props, ref: Ref<SVGSVGElement>) => {
  const titleId = title;
  const style = {
    height: size.toString(10).concat('px'),
    width: size.toString(10).concat('px'),
    ...(rotate && {
      transform: 'rotate('.concat(rotate.toString(10)).concat('deg)')
    })
  };
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" focusable="false" role="img" style={style} className={className} ref={ref} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clipRule="evenodd" /></svg>;
};
const ForwardRef = forwardRef(SvgCheckCircleSolid);
export default ForwardRef;